import { render, staticRenderFns } from "./AppFooter.vue?vue&type=template&id=2440f3ba&scoped=true"
var script = {}
import style0 from "./AppFooter.vue?vue&type=style&index=0&id=2440f3ba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2440f3ba",
  null
  
)

export default component.exports